(function () {
  'use strict';

  var activeRequest = null;

  function closestOptions(element) {
    return element && element.closest('[data-high-variant-options]');
  }

  function optionSources(options) {
    return Array.prototype.slice.call(options.querySelectorAll('[data-product-option]'));
  }

  function selectedValueIds(options) {
    return optionSources(options).map(function (source) {
      var selected = source.options ? source.options[source.selectedIndex] : source;
      return selected && selected.dataset.optionValueId;
    }).filter(Boolean);
  }

  function parseGoldValue(value) {
    var text = String(value || '').trim();
    var slashParts = text.split(' / ');
    if (slashParts.length === 2) {
      if (/^\d+K$/i.test(slashParts[0])) {
        return { color: slashParts[1], karat: slashParts[0].toUpperCase() };
      }
      return { color: slashParts[0], karat: slashParts[1].toUpperCase() };
    }

    var compact = text.match(/^(\d+K)\s+(Yellow|White|Rose)\s+Gold$/i);
    if (compact) {
      return {
        color: compact[2].charAt(0).toUpperCase() + compact[2].slice(1).toLowerCase() + ' Gold',
        karat: compact[1].toUpperCase()
      };
    }

    return { color: 'Yellow Gold', karat: '10K' };
  }

  function selectedGold(source) {
    return parseGoldValue(source.value);
  }

  function goldOption(source, color, karat) {
    return Array.prototype.find.call(source.options, function (option) {
      var parsed = parseGoldValue(option.value);
      return parsed.color === color && parsed.karat === karat;
    });
  }

  function renderControls(options) {
    var combined = options.querySelector('[data-combined-gold-selector]');
    if (combined) {
      var source = options.querySelector('.combined-gold-source');
      var selected = selectedGold(source);
      var colorButtons = combined.querySelectorAll('[data-gold-color]');
      var karatButtons = combined.querySelectorAll('[data-gold-karat]');

      Array.prototype.forEach.call(colorButtons, function (button) {
        var hasAvailableCombination = Array.prototype.some.call(source.options, function (option) {
          return parseGoldValue(option.value).color === button.dataset.goldColor && !option.disabled;
        });
        button.disabled = !hasAvailableCombination;
        button.setAttribute('aria-pressed', String(button.dataset.goldColor === selected.color));
      });

      Array.prototype.forEach.call(karatButtons, function (button) {
        var existsForAnyColor = Array.prototype.some.call(source.options, function (option) {
          return parseGoldValue(option.value).karat === button.dataset.goldKarat;
        });
        var match = goldOption(source, selected.color, button.dataset.goldKarat);
        button.hidden = !existsForAnyColor;
        button.style.display = existsForAnyColor ? '' : 'none';
        button.disabled = !match || match.disabled;
        button.title = button.disabled ? 'Not available in ' + selected.color : '';
        button.setAttribute('aria-pressed', String(button.dataset.goldKarat === selected.karat));
      });

      var colorCurrent = combined.querySelector('[data-gold-color-current]');
      var karatCurrent = combined.querySelector('[data-gold-karat-current]');
      var note = combined.querySelector('[data-gold-availability-note]');
      if (colorCurrent) colorCurrent.textContent = selected.color;
      if (karatCurrent) karatCurrent.textContent = selected.karat;
      if (note) {
        var yellowOnly = Array.prototype.filter.call(karatButtons, function (button) {
          var yellow = goldOption(source, 'Yellow Gold', button.dataset.goldKarat);
          var current = goldOption(source, selected.color, button.dataset.goldKarat);
          return !button.hidden && selected.color !== 'Yellow Gold' && yellow && !yellow.disabled && (!current || current.disabled);
        }).map(function (button) { return button.dataset.goldKarat; });
        note.textContent = yellowOnly.join(' and ') + (yellowOnly.length === 1 ? ' is' : ' are') + ' available in Yellow Gold only.';
        note.hidden = yellowOnly.length === 0;
      }
    }

    Array.prototype.forEach.call(options.querySelectorAll('[data-option-bubbles]'), function (bubbles) {
      var wrapper = bubbles.closest('.product-details__option-wrapper--bubble-select');
      var source = wrapper && wrapper.querySelector('.option-bubbles-source');
      if (!source) return;
      Array.prototype.forEach.call(bubbles.querySelectorAll('[data-option-bubble-value]'), function (button) {
        var match = Array.prototype.find.call(source.options, function (option) {
          return option.value === button.dataset.optionBubbleValue;
        });
        button.disabled = !match || match.disabled;
        button.title = button.disabled ? 'Not available with the selected options' : '';
        button.setAttribute('aria-pressed', String(button.dataset.optionBubbleValue === source.value));
      });
      var current = bubbles.querySelector('[data-option-bubbles-current]');
      var selectedButton = Array.prototype.find.call(bubbles.querySelectorAll('[data-option-bubble-value]'), function (button) {
        return button.dataset.optionBubbleValue === source.value;
      });
      if (current) current.textContent = selectedButton ? selectedButton.textContent.trim() : source.value;
    });
  }

  function sectionData(root) {
    var script = root.querySelector('[data-section-data]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (error) { return null; }
  }

  function copyVariantDisplay(currentSection, nextSection, variant, settings) {
    var selectors = [
      '[data-product-price]',
      '[data-product-price-compare]',
      '[data-tax-line]',
      '[data-unit-price]',
      '[data-product-atc]'
    ];

    selectors.forEach(function (selector) {
      var current = currentSection.querySelector(selector);
      var next = nextSection.querySelector(selector);
      if (!current || !next) return;
      if (selector === '[data-product-atc]') {
        current.disabled = next.disabled;
        var currentText = current.querySelector('[data-product-atc-text]');
        var nextText = next.querySelector('[data-product-atc-text]');
        if (currentText && nextText) currentText.textContent = nextText.textContent;
      } else {
        current.className = next.className;
        current.innerHTML = next.innerHTML;
      }
    });

    var hiddenId = currentSection.querySelector('[data-high-variant-id]');
    if (hiddenId && variant) {
      hiddenId.value = variant.id;
      hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (variant && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.delete('option_values');
      url.searchParams.set('variant', variant.id);
      history.replaceState({ path: url.toString() }, '', url.toString());
    }

    if (variant) {
      document.dispatchEvent(new CustomEvent('shopify-variants:switch-variant', {
        detail: { product: settings && settings.product, variant: variant }
      }));
    }
  }

  function loadSelection(options) {
    var ids = selectedValueIds(options);
    if (!ids.length) return;

    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();
    options.setAttribute('aria-busy', 'true');

    var url = new URL(options.dataset.productUrl, window.location.origin);
    url.searchParams.set('option_values', ids.join(','));
    url.searchParams.set('section_id', options.dataset.sectionId);

    fetch(url.toString(), { signal: activeRequest.signal, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Section request failed');
        return response.text();
      })
      .then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var nextOptions = documentFragment.querySelector('[data-high-variant-options]');
        var currentSection = options.closest('[data-section-type="product-template"]');
        var nextSection = documentFragment.querySelector('[data-section-type="product-template"]');
        var data = sectionData(documentFragment);
        if (!nextOptions || !currentSection || !nextSection || !data || !data.selectedVariant) {
          throw new Error('Variant response was incomplete');
        }

        options.replaceWith(nextOptions);
        renderControls(nextOptions);
        copyVariantDisplay(currentSection, nextSection, data.selectedVariant, data);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        var fallback = new URL(options.dataset.productUrl, window.location.origin);
        fallback.searchParams.set('option_values', ids.join(','));
        window.location.assign(fallback.toString());
      })
      .finally(function () {
        var current = document.querySelector('[data-high-variant-options]');
        if (current) current.setAttribute('aria-busy', 'false');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gold-color], [data-gold-karat], [data-option-bubble-value]');
    var options = closestOptions(button);
    if (!button || !options || button.disabled) return;

    if (button.matches('[data-option-bubble-value]')) {
      var bubbleWrapper = button.closest('.product-details__option-wrapper--bubble-select');
      var bubbleSource = bubbleWrapper && bubbleWrapper.querySelector('.option-bubbles-source');
      if (!bubbleSource) return;
      bubbleSource.value = button.dataset.optionBubbleValue;
    } else {
      var source = options.querySelector('.combined-gold-source');
      if (!source) return;
      var selected = selectedGold(source);
      var color = button.dataset.goldColor || selected.color;
      var karat = button.dataset.goldKarat || selected.karat;
      var match = goldOption(source, color, karat);
      if (!match || match.disabled) {
        match = Array.prototype.find.call(source.options, function (option) {
          return parseGoldValue(option.value).color === color && !option.disabled;
        });
      }
      if (!match) return;
      source.value = match.value;
    }

    renderControls(options);
    loadSelection(options);
  });

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-high-variant-options]'), renderControls);
  });
}());
